export const getImagePath = (imageName) => {
  return `${process.env.PUBLIC_URL}/images/${imageName}`;
}; 